
import { Placement } from '@post-office/placements-frontend/jira-filter-refinement-filter-button';
export default Placement;
